import * as React from "react";
import { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import InDepthAccordian from "../../../commonComponents/InDepthAccordian";
import NoMarket from "../../../commonComponents/NoMarkets";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const LiveRanks = ({ liveRanks, isClosedContest }) => {
  const [liveRankInDepthShow, setLiveRankInDepth] = useState(false);
  return (
    <>
      {liveRanks?.length !== 0 ? (
        <View
          style={{
            borderWidth: 0.75,
            borderColor: Colors.borderColor,
            borderRadius: 8,
            marginBottom: 50,
            //flex: 1,
          }}
        >
          <View style={styles.headerParent}>
            <FormTextLabel labelStyles={[styles.colStyle, styles.headerCol]} label={"USER"} />
            <FormTextLabel
                labelStyles={[styles.colStyle, styles.center, styles.headerCol]}
                label={isClosedContest ? "REWARDS" : "TRADING PROFIT"}
            />
            <FormTextLabel labelStyles={[styles.colStyle, styles.right, styles.headerCol]} label={"CURRENT RANK"} />
          </View>
          <View>
            <FlatList
              nestedScrollEnabled={true}
              contentContainerStyle={
                {
                  //paddingBottom: 10,
                }
              }
              data={liveRankInDepthShow ? liveRanks : liveRanks.slice(0, 5)}
              renderItem={({ item, index }) => {
                return (
                  <View
                    style={[
                      styles.rowStyle,
                      liveRanks.length - 1 === index
                        ? { borderWidth: 0 }
                        : null,
                    ]}
                  >
                    <Text
                      style={[styles.colStyle, styles.rowTxt]}
                      numberOfLines={1}
                    >
                      {item?.user}
                    </Text>
                    <Text
                      style={[
                        styles.colStyle,
                        styles.center,
                        styles.rowTxt,
                        {
                          color: item?.profit >= 0 ? Colors.green : Colors.red,
                        },
                      ]}
                    >
                      {item?.profit >= 0 ? "+" : "-"}
                      {item?.profit?.toFixed(2)}
                    </Text>
                    <Text
                      style={[styles.colStyle, styles.center, styles.rowTxt]}
                    >
                      {item?.rank}
                    </Text>
                  </View>
                );
              }}
              keyExtractor={(item, index) => index}
              showsVerticalScrollIndicator={false}
              initialNumToRender={10}
            />
            {liveRanks.length > 5 && (
              <InDepthAccordian
                setLiveRankInDepth={setLiveRankInDepth}
                liveRankInDepthShow={liveRankInDepthShow}
              />
            )}
          </View>
        </View>
      ) : (
        <NoMarket innerContestCondition={true} source="contest_leaderboard" />
      )}
    </>
  );
};

export default LiveRanks;

const styles = StyleSheet.create({
  colStyle: {
    flex: 1,
    flexBasis: 0,
  },
  headerCol: {
    ...globalFontStyle.appFontSmallText,
    lineHeight: 19,
    color: Colors.lightgrey,
  },
  headerParent: {
    backgroundColor: Colors.grey3,
    paddingHorizontal: 15,
    paddingVertical: 9,
    flexDirection: "row",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  rowTxt: {
    ...globalFontStyle.appFontSubText,
    lineHeight: 19,
    color: Colors.black1,
    alignItems: "center",
    width: 0,
  },
  rowStyle: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 15,
    paddingVertical: 9,
    borderBottomWidth: 0.2,
    borderBottomColor: "#DBDBDB",
  },
});
